// Interaction Types
export const CAMPAIGN_TELEPHONY = 'CAMPAIGN TELEPHONY';
export const INCOMING_TELEPHONY = 'INCOMING TELEPHONY';
export const DIRECT_INCOMING_TELEPHONY = 'DIRECT INCOMING CALL';
export const CALLBACK_TELEPHONY = 'CALLBACK TELEPHONY';
export const INTERNAL_CALL = 'OUT. INTERNAL TELEPHONY';
export const EXTERNAL_CALL = 'OUT. EXTERNAL TELEPHONY';

export const INCOMING_CHAT = 'INCOMING CHAT';
export const INTERNAL_CHAT = 'INTERNAL MESSAGING (CHAT)';

export const INCOMING_EMAIL = 'INCOMING EMAIL';
export const OUTGOING_EMAIL = 'OUT. EXTERNAL MAIL';

export const INCOMING_SMS = 'INCOMING SMS';
export const OUTGOING_SMS = 'OUT. EXTERNAL SMS';

// Interaction Media Types
export const MEDIA_TYPE_TELEPHONY = 'TELEPHONY';
export const MEDIA_TYPE_CHAT = 'CHAT';
export const MEDIA_TYPE_EMAIL = 'EMAIL';
export const MEDIA_TYPE_SMS = 'SMS';

// Interaction message states
export const IDLE = 'IDLE';
export const REGULAR = 'REGULAR';
export const SYSTEM = 'SYSTEM';
export const TEXT_ENTERED = 'TEXTENTERED';

// Interaction & element states
export const STATE_MISSED = 'MISSED';

// Element states by ID
export const NOT_SELECTED_TIMEOUT_DISPOSITION_CODE_ID = '737e4d5d-8594-400d-98a0-77566895a0e9';
